import { RouteRecordRaw } from 'vue-router'
import userChildRoutes from '@/router/user'

const routes: Array<RouteRecordRaw> = [
  {
    path: 'list',
    name: 'manage.users.list',
    component: () => import('@/views/control-panel/manage/users/List.vue'),
  },
  {
    path: ':user',
    name: 'manage.user',
    component: () => import('@/views/control-panel/manage/users/User.vue'),
    redirect: (to) => ({ name: 'manage.user.edit', params: to.params }),
    children: userChildRoutes
  },
  {
    path: 'create',
    name: 'manage.users.create',
    component: () => import('@/views/control-panel/manage/users/Create.vue'),
  }
]

export default routes
